import { render, staticRenderFns } from "./DormTabNavCity.vue?vue&type=template&id=20c8a86b&scoped=true&"
import script from "./DormTabNavCity.vue?vue&type=script&lang=js&"
export * from "./DormTabNavCity.vue?vue&type=script&lang=js&"
import style0 from "./DormTabNavCity.vue?vue&type=style&index=0&id=20c8a86b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8a86b",
  null
  
)

export default component.exports